import { redirect } from 'react-router-dom';
import { getAvailableProjectStatuses, projectQuery } from '../../api-v2/queries/project-query';
import { getCard } from '../../api-v2/queries/card-queries';
import { getChat, getChatMessage } from '../../api-v2/queries/assistant/chat-queries';

export const projectDetailPageLoader = (queryClient) => async (opts) => {
  const { projectId, tab } = opts.params;

  queryClient.ensureQueryData({
    ...projectQuery({ projectId, groupView: true }),
    revalidateIfStale: true,
  });
  queryClient.ensureQueryData(getAvailableProjectStatuses({ projectId }));

  return { projectId, tab };
};

export const projectDetailQueryPageLoader = (queryClient) => async (opts) => {
  const url = new URL(opts.request.url);
  const id = url.searchParams.get('id');

  queryClient.ensureQueryData(projectQuery({ projectId: id, groupView: true }));

  return { projectId: id };
};

export const redirectLoader = (opts) => {
  const url = new URL(opts.request.url);
  const id = url.searchParams.get('id');
  const card = url.searchParams.get('card');
  const navbars = url.searchParams.get('navbars');

  let redirectUrl = `/projects/${id}`;

  if (card) {
    redirectUrl += `/tasks/${card}`;
  }

  if (navbars === 'False') {
    redirectUrl += `?navbars=False`;
  }

  return redirect(redirectUrl);
};

export const projectTaskPageLoader = (_queryClient) => async (opts) => {
  const { projectId, taskId } = opts.params;

  // queryClient.ensureQueryData(projectQuery({ projectId, groupView: true }));

  return { projectId, taskId };
};

export const projectTaskGroupPageLoader = (queryClient) => async (opts) => {
  const { projectId, taskGroupId } = opts.params;

  await queryClient.ensureQueryData(projectQuery({ projectId }));
  await queryClient.ensureQueryData(getCard({ cardId: taskGroupId }));

  return { projectId, taskGroupId };
};

export const loadExistingChat = (queryClient) => async (opts) => {
  const { chatId } = opts.params;

  await queryClient.ensureQueryData(getChat({ chatId }));

  return { chatId };
};

export const loadExistingChatMessage = (queryClient) => async (opts) => {
  const { chatId, messageId, projectId } = opts.params;

  await queryClient.ensureQueryData(getChat({ chatId }));
  await queryClient.ensureQueryData(getChatMessage({ chatId, messageId }));

  return { chatId, messageId, projectId };
};
